import {t} from "@lingui/core/macro";

import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {Body, HeadingMedium} from "@khanacademy/wonder-blocks-typography";
import {ErrorMessageWrapper} from "@khan/component-error-message";
import {ReportError} from "@khan/component-screens/error-loading";

/**
 * Renders the error content for the guide transcripts query.
 */
const GuideTranscriptsError = (): React.ReactNode => {
    return (
        <ErrorMessageWrapper>
            <HeadingMedium style={{textAlign: "center"}}>
                {t`Oops. Something went wrong. Please try again.`}
            </HeadingMedium>
            <Body
                style={{
                    textAlign: "center",
                    marginBlockStart: spacing.xLarge_32,
                }}
            >
                <ReportError />
            </Body>
        </ErrorMessageWrapper>
    );
};

export {GuideTranscriptsError as GuideTranscriptsError};
